import React, { useState, createContext, useEffect, useContext } from 'react';
import { db } from '../utils/firebase';
import { AuthContext } from './AuthContext';

export const UsersContext = createContext();

export function UsersProvider({ children }) {
  const [users, setUsers] = useState([]);
  const [USERS, setUSERS] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState({});
  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    if (currentUser) {
      db.collection('users').onSnapshot((snapshot) => {
        setUsers(snapshot.docs.map((doc) => ({ ...doc.data(), email: '' })));
        setUSERS(snapshot.docs.map((doc) => ({ ...doc.data(), email: '' })));
        setIsLoading(false);
      });
    } else {
      setUsers([]);
      setUSERS([]);
      setSelectedUser({});
    }
  }, [currentUser]);

  return (
    <UsersContext.Provider
      value={{
        users: [users, setUsers],
        selectedUser: [selectedUser, setSelectedUser],
        USERS,
        isLoading,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
}
